// extracted by mini-css-extract-plugin
export default {"image":"banner_image__FhdJe","imageBottom":"banner_imageBottom__p-ztC"};